// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__Oz8id","list":"PatternAutocomplete_list__qHwZC"};